import React from 'react';

import Section from '../../../HOC/Section';
import bgImage from '../../../assets/img/goldnarHome.png';
import Link from '../../UI/Link/Link';

const home = () => {
  return (
    <Section id='home'>
      <div>
        <div
          className='home-content p-5'
          style={{ backgroundImage: `url(${bgImage})` }}
        >
          <div className='intro container text-center text-light'>
            <h1 className='title'>ERZİNCAN GOLD NAR <br/>GÜZELLİK MERKEZİ</h1>
            <h2 className='sub-title mb-4'>
              Cilt bakımı, lazer epilasyon ve bölgesel bakım uygulamalarında modern, hijyenik ve özenli salon deneyimi.
            </h2>
            <Link target='contact' classes='btn btn-primary home-contact-btn mr-2'>
              İletişime Geç
            </Link>
            <a
              href="https://share.google/wj8How7D9GaZvJJha"
              target="_blank"
              rel="noopener noreferrer"
              className='btn btn-outline-light'
            >
              Yol Tarifi Al
            </a>
          </div>
        </div>
      </div>
    </Section>
  );
};

export default home;
